import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: auth.SyncError.
export default class StatusSyncError extends Fragment {
  declare [Type]: 'auth/status-sync-error';

  // entityId provides the type's main entity id, that is, personId for a
  // 'user' or a 'clientId' for a client.
  @attr('string', { defaultValue: '' })
  declare entityId: string;

  // username provides the registered email address for a user.
  @attr('string', { defaultValue: '' })
  declare username: string;

  // name provides a human understandable name of the entity.
  @attr('string', { defaultValue: '' })
  declare name: string;

  // errorDescription provides details about the error that has occured.
  @attr('string', { defaultValue: '' })
  declare errorDescription: string;
}
